import { apiClient } from "./apiClient";

const auth = (accessToken) => ({ headers: { Authorization: `Bearer ${accessToken}` } });

// Superadmin: a tenant's capability matrix -> { capabilities: [{ capability, granted, delegatable }] }
export async function getTenantCapabilities(accessToken, tenantId) {
  const res = await apiClient.get(`/admin/tenants/${tenantId}/capabilities`, auth(accessToken));
  return res.data;
}

// Full replacement of the granted (delegatable) set; same shape back as GET
export async function updateTenantCapabilities(accessToken, tenantId, capabilities) {
  const res = await apiClient.put(`/admin/tenants/${tenantId}/capabilities`, { capabilities }, auth(accessToken));
  return res.data;
}

// Superadmin: a tenant's product profile -> { tenant_id, products: ["iot" | "cra"] }; "cra" also grants security.sbom
export async function getTenantProducts(accessToken, tenantId) {
  const res = await apiClient.get(`/admin/tenants/${tenantId}/products`, auth(accessToken));
  return res.data;
}

export async function updateTenantProducts(accessToken, tenantId, products) {
  const res = await apiClient.put(`/admin/tenants/${tenantId}/products`, { products }, auth(accessToken));
  return res.data;
}

// edge.transfer: -> { status: "approved" | "pending", transfer_id }
export async function transferEdge(accessToken, edgeDbId, targetTenantId) {
  const res = await apiClient.post(`/admin/edges/${edgeDbId}/transfer`, { target_tenant_id: targetTenantId }, auth(accessToken));
  return res.data;
}

export async function listEdgeTransfers(accessToken, status = "pending") {
  const res = await apiClient.get("/admin/edge-transfers", { ...auth(accessToken), params: { status } });
  return res.data;
}

export async function approveEdgeTransfer(accessToken, transferId) {
  const res = await apiClient.post(`/admin/edge-transfers/${transferId}/approve`, {}, auth(accessToken));
  return res.data;
}

export async function rejectEdgeTransfer(accessToken, transferId) {
  const res = await apiClient.post(`/admin/edge-transfers/${transferId}/reject`, {}, auth(accessToken));
  return res.data;
}

// edge.tier.change: -> updated edge; 409 with detail when pro has no valid license
export async function changeEdgeTier(accessToken, edgeDbId, tier) {
  const res = await apiClient.post(`/admin/edges/${edgeDbId}/tier`, { tier }, auth(accessToken));
  return res.data;
}
